import { render } from "./WorkerDetail.vue?vue&type=template&id=5a0c31f0"
import script from "./WorkerDetail.vue?vue&type=script&lang=js"
export * from "./WorkerDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__